import React from 'react';

import { NamedUserAvatarWithUser } from '../../common/named-user-avatar';

interface IActivityPropertyUser {
  value?: string | null;
}

// ActivityProperty User = 7
export const ActivityPropertyUser = ({ value }: IActivityPropertyUser) => {
  const userCloudId = !value ? '' : value;

  return (
    <NamedUserAvatarWithUser
      userId={userCloudId}
      avatarSize="xsmall"
      textSize="small"
    />
  );
};
